import { IntrospectionFragmentMatcher } from "apollo-boost";

export const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: {
    __schema: {
      types: [
        {
          kind: "UNION",
          name: "Activity",
          possibleTypes: [
            {
              name: "OutageStart"
            },
            {
              name: "OutageEnd"
            },
            {
              name: "Deploy"
            },
            {
              name: "Commit"
            }
          ]
        },
        {
          kind: "SCALAR",
          name: "Boolean",
          possibleTypes: []
        },
        {
          kind: "OBJECT",
          name: "Commit",
          possibleTypes: []
        },
        {
          kind: "OBJECT",
          name: "Contributor",
          possibleTypes: []
        },
        {
          kind: "OBJECT",
          name: "Deploy",
          possibleTypes: []
        },
        {
          kind: "SCALAR",
          name: "Float",
          possibleTypes: []
        },
        {
          kind: "OBJECT",
          name: "Function",
          possibleTypes: []
        },
        {
          kind: "SCALAR",
          name: "ID",
          possibleTypes: []
        },
        {
          kind: "SCALAR",
          name: "Int",
          possibleTypes: []
        },
        {
          kind: "SCALAR",
          name: "Map",
          possibleTypes: []
        },
        {
          kind: "OBJECT",
          name: "OutageEnd",
          possibleTypes: []
        },
        {
          kind: "OBJECT",
          name: "OutageStart",
          possibleTypes: []
        },
        {
          kind: "OBJECT",
          name: "Project",
          possibleTypes: []
        },
        {
          kind: "OBJECT",
          name: "Query",
          possibleTypes: []
        },
        {
          kind: "OBJECT",
          name: "Repository",
          possibleTypes: []
        },
        {
          kind: "SCALAR",
          name: "String",
          possibleTypes: []
        },
        {
          kind: "SCALAR",
          name: "Time",
          possibleTypes: []
        },
        {
          kind: "OBJECT",
          name: "__Directive",
          possibleTypes: []
        },
        {
          kind: "ENUM",
          name: "__DirectiveLocation",
          possibleTypes: []
        },
        {
          kind: "OBJECT",
          name: "__EnumValue",
          possibleTypes: []
        },
        {
          kind: "OBJECT",
          name: "__Field",
          possibleTypes: []
        },
        {
          kind: "OBJECT",
          name: "__InputValue",
          possibleTypes: []
        },
        {
          kind: "OBJECT",
          name: "__Schema",
          possibleTypes: []
        },
        {
          kind: "OBJECT",
          name: "__Type",
          possibleTypes: []
        },
        {
          kind: "ENUM",
          name: "__TypeKind",
          possibleTypes: []
        }
      ]
    }
  }
});

export default fragmentMatcher;
